import {
  Autocomplete,
  Checkbox,
  Grid,
  ListItemText,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { statiModificaAnagraficaECampi, statiModificaPermessa } from 'enums/constants-creazione-modifica-pratica'
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isValidUser } from '../../OnlyWithFunctions';
import { StyledButton } from '../../UI/StyledButton';
import { StatiPratica } from '../../utils/StatiPratica';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function AdeguataVerificaFormModal({
  errorState,
  disabledButton,
  loading,
  errorCF,
  onClick,
  defaultValues,
  idNodoPratica,
  responseDettaglioRelazione,
  handleViewModal,
}) {
  const theme = useTheme();
  const location = useLocation();
  const isAmlDesk = isValidUser('SUPPORTO_AML_DESK');
  const isAml = isValidUser('SUPPORTO_FUNZIONE_AML');
  const userCanAssign = isValidUser('ASSEGNA_PRATICA');

  const statoRichiesta =
    defaultValues.statoPratica;
  const [listOptionalDocNames, setListOptionalDocNames] = useState([]);
  const [verificaRafforzataInRelazioneA, setVerificaRafforzataInRelazioneA] = useState([]);
  const [listaAAR, setListaAAR] = useState([]);
  const [listaAMR, setListaAMR] = useState([]);
  const [listaMMR, setListaMMR] = useState([]);
  const [listaMAR, setListaMAR] = useState([]);
  const [tipologiaCliente, setTipologiaCliente] = useState([]);
  const [daAssegnareA, setDaAssegnareA] = useState([]);
  const [listRelazioneA, setListRelazioneA] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [isFieldFocused, setIsFieldFocused] = useState(false);
  const [assegnareA, setAssegnareA] = useState('');

  const daAssegnareAbilitato = (userCanAssign && statiModificaPermessa.includes(statoRichiesta));
  const modificaCampiVariAbilitato = ((defaultValues.daAssegnare === JSON.parse(localStorage.getItem('user')) || userCanAssign) && statiModificaAnagraficaECampi.includes(statoRichiesta))

  const initialState = {
    idNodoPratica: idNodoPratica ? idNodoPratica : '',
    NDG: defaultValues ? defaultValues.ndg : '',
    indirizzo: defaultValues ? defaultValues.indirizzo : '',
    Citta: defaultValues ? defaultValues.citta : '',
    nazione: defaultValues ? defaultValues.nazione : '',
    ragioneSociale: defaultValues ? defaultValues.ragioneSociale : '',
    codiceFiscale: defaultValues ? defaultValues.codiceFiscale : '',
    nomePratica: defaultValues ? defaultValues.nomePratica : '',
    tipologiaCliente: defaultValues ? defaultValues.tipologiaCliente : '',
    tipologiaDiRichiesta: defaultValues
      ? defaultValues.tipoInserimento : '',
    tipologiaOperativita: defaultValues ? defaultValues.verificaRafforzataProdotto : '',
    relazione: defaultValues ? defaultValues.relazione : '',
    motivazioneRichiesteOpzionali: defaultValues ? defaultValues.motivazioneRichiesteOpzionali : '',
    //documentiOpzionaliVari: defaultValues ? defaultValues.documentiOpzionaliVari : '',
    daAssegnare: defaultValues ? defaultValues.daAssegnare : '',
    dettaglioRelazione: defaultValues ? defaultValues.dettaglioMotivazione : '',
    tipoInserimento: defaultValues ? defaultValues.tipoInserimento : '',
    // dettaglioKey: defaultValues ? defaultValues['folder_model:dettaglioKey'] : '',
    statoRichiesta: defaultValues ? defaultValues.StatiPratica : '',
    gruppoUtenteCreatore: defaultValues ? defaultValues.utenteCreatore : '',
  };
  console.log('STATO',initialState)

  useEffect(() => {
    const loadDataFromLocalStorage = () => {
      try {
        //setListOptionalDocNames(JSON.parse(localStorage.getItem('DocumentiOpzionaliVari')) || []);
        setVerificaRafforzataInRelazioneA(JSON.parse(localStorage.getItem('VerificaRafforzataInRelazioneA')) || []);
        setListaAAR(JSON.parse(localStorage.getItem('motivazioniAAR')) || []);
        setListaAMR(JSON.parse(localStorage.getItem('motivazioniAMR')) || []);
        setListaMMR(JSON.parse(localStorage.getItem('motivazioniMMR')));
        setListaMAR(JSON.parse(localStorage.getItem('motivazioniMAR')) || []);
        setTipologiaCliente(JSON.parse(localStorage.getItem('TipologiaCliente')) || []);
        setDaAssegnareA(JSON.parse(localStorage.getItem('DaAssegnareA')) || []);
        setDataLoaded(true);
      } catch (error) {
        console.error('Errore nel parsing dei dati dal localStorage:', error);
      }
    };

    loadDataFromLocalStorage();
  }, []);

  useEffect(() => {
    if (initialState?.tipologiaDiRichiesta === 'Automatica Alto Rischio') {
      setListRelazioneA(listaAAR);
      setIsHighRiskOrMediumRisk(true);
    } else if (initialState?.tipologiaDiRichiesta === 'Automatica Medio Rischio') {
      setListRelazioneA(listaAMR);
      setIsHighRiskOrMediumRisk(true);
    } else if (initialState?.tipologiaDiRichiesta === 'Manuale Alto Rischio') {
      setListRelazioneA(listaMAR);
    } else if (initialState?.tipologiaDiRichiesta === 'Manuale Medio Rischio') {
      setListRelazioneA(listaMMR);
    }
  }, [
    listaMAR,
    listaMMR,
    listaAAR,
    listaAMR,
    initialState?.tipologiaDiRichiesta
  ]);



/*  const [existingOptionalDocName, setExistingOptionalDocName] = useState(
    defaultValues && defaultValues.documentiOpzionaliVari
      ? defaultValues.documentiOpzionaliVari
      : [],
  );*/

  const [existingRelazione, setExistingRelazione] = useState(
    defaultValues && defaultValues.relazione
      ? defaultValues.relazione.split(', ')
      : [],
  );

  const [showNote, setShowNote] = useState(false);
  const [showDettagliorelazione, setShowDettagliorelazione] = useState(false);
  const [formValues, setFormValues] = useState(initialState);
  const [isHighRiskOrMediumRisk, setIsHighRiskOrMediumRisk] = useState(false);

  const handleChange = event => {
    event.preventDefault();
    const { name, value } = event.target;

    let newValue = value;
    if ((name === 'NDG' || name === 'ragioneSociale') && value.trim() === '') {
      newValue = '';
    }

    setFormValues({
      ...formValues,
      [name]: newValue,
    });

  };

  const multiChangeMotivazioni = event => {
    const {
      target: { value },
    } = event;

    setExistingRelazione(
      typeof value === 'string' ? value.split(',') : value,
    );

    if (value.includes('Altro') || value.includes('Esito Monitoraggio')) {
      setShowDettagliorelazione(true);
    } else {
      setShowDettagliorelazione(false);
      setFormValues(prev => ({
        ...prev,
        dettaglioRelazione: '',
      }));
    }
  };

/*  useEffect(() => {
    if (existingOptionalDocName && existingOptionalDocName.length !== 0) {
      setShowNote(true);
    } else if (existingOptionalDocName && existingOptionalDocName.length === 0) {
      setShowNote(false);
    }
  }, [existingOptionalDocName]);*/

  useEffect(() => {
    if (existingRelazione.includes('Altro') || existingRelazione.includes('Esito Monitoraggio')) {
      setShowDettagliorelazione(true);
    } else {
      setShowDettagliorelazione(false);
    }
  }, [existingRelazione]);

/*  useEffect(() => {
    setFormValues({
      ...formValues,
      documentiOpzionaliVari: existingOptionalDocName,
    });
  }, [existingOptionalDocName]);*/

  useEffect(() => {
    setFormValues({
      ...formValues,
      relazione: existingRelazione,
    });
  }, [existingRelazione]);

  return (
    <Stack
      sx={{ backgroundColor: '#FFFFFF' }}
      alignContent="space-center"
      spacing={{ xs: 10, md: 2, lg: 2, xl: 2 }}
    >
      {dataLoaded ? (
        <>
          <Grid
            container
            padding="20px"
            mt={{ xs: 18, lg: 8, xl: -3 }}
            spacing={{ xs: 20, md: 1 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
            justifyItems="center"
          >
            <Grid item xs={3}>
              <TextField
                disabled={!modificaCampiVariAbilitato}
                sx={{ width: '95%' }}
                onChange={handleChange}
                name={'NDG'}
                error={!isHighRiskOrMediumRisk && errorState && (formValues.NDG === undefined || formValues.NDG === '')}
                value={formValues.NDG}
                id="standard-basic"
                label={isHighRiskOrMediumRisk ? 'NDG' : 'NDG *'}
                variant="standard"
                margin="dense"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                sx={{ mt: 1, width: '95%' }}
                onChange={handleChange}
                disabled={!modificaCampiVariAbilitato}
                name={'ragioneSociale'}
                error={errorState && (formValues.ragioneSociale === undefined || formValues.ragioneSociale === '' || formValues.ragioneSociale.length > 100)}
                value={formValues.ragioneSociale}
                required
                id="standard-basic"
                label="Ragione Sociale"
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                sx={{ mt: 1, width: '95%' }}
                onChange={handleChange}
                disabled={!modificaCampiVariAbilitato}
                name={'codiceFiscale'}
                error={errorState && (formValues.codiceFiscale === undefined || formValues.codiceFiscale === '')}
                value={formValues.codiceFiscale}
                id="standard-basic"
                label="Codice Fiscale *"
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                sx={{ mt: 1, width: '95%' }}
                onChange={handleChange}
                disabled={!modificaCampiVariAbilitato}
                name={'nazione'}
                value={formValues.nazione}
                id="standard-basic"
                label="Nazione"
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                sx={{ mt: 1, width: '95%' }}
                onChange={handleChange}
                disabled={!modificaCampiVariAbilitato}
                name={'indirizzo'}
                value={formValues.indirizzo}
                id="standard-basic"
                label="Indirizzo"
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                sx={{ mt: 1, width: '95%' }}
                onChange={handleChange}
                disabled={!modificaCampiVariAbilitato}
                name={'Citta'}
                value={formValues.Citta}
                id="standard-basic"
                label="Città"
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                sx={{ mt: 1, width: '95%' }}
                onChange={handleChange}
                disabled={!modificaCampiVariAbilitato}
                name={'nomePratica'}
                value={formValues.nomePratica}
                id="standard-basic"
                label="Nome Pratica"
                variant="standard"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                select
                sx={{ mt: 1, width: '95%' }}
                variant="standard"
                label="Tipologia cliente"
                onChange={handleChange}
                disabled={!modificaCampiVariAbilitato}
                value={formValues.tipologiaCliente}
                inputProps={{
                  name: 'tipologiaCliente',
                  id: 'uncontrolled-native',
                }}
              >
                {tipologiaCliente.map(name => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <Grid
            container
            padding="10px"
            paddingRight="20px"
            justifyContent={'end'}
            alignContent={'center'}
            sx={{
              backgroundColor: theme.palette.blue.light,
            }}
          >
            <Grid
              container
              paddingBottom="10px"
              columns={{ xs: 4, sm: 8, md: 12 }}
              spacing={3}
              item
              xs={12}
              padding="10px"
            >
              <Grid item xs={4}>
                <Tooltip title={formValues.tipologiaDiRichiesta} placement="top">
                  <TextField
                    select
                    helperText="Tipologia di richiesta"
                    sx={{ width: '100%' }}
                    variant="standard"
                    defaultValue={formValues.tipologiaDiRichiesta}
                    onChange={handleChange}
                    disabled
                    margin="dense"
                    inputProps={{
                      name: 'tipologiaDiRichiesta',
                      id: 'uncontrolled-native',
                    }}
                  >
                    <MenuItem value={formValues.tipologiaDiRichiesta}>{formValues.tipologiaDiRichiesta}</MenuItem>
                  </TextField>
                </Tooltip>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  select
                  sx={{ mt: 1, width: '100%' }}
                  variant="standard"
                  helperText="Verifica rafforzata in relazione al seguente prodotto"
                  onChange={handleChange}
                  disabled={!modificaCampiVariAbilitato}
                  margin="dense"
                  value={formValues.tipologiaOperativita}
                  inputProps={{
                    name: 'tipologiaOperativita',
                    id: 'uncontrolled-native',
                  }}
                >
                  {verificaRafforzataInRelazioneA.map(name => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <Tooltip
                  title={
                    !isFieldFocused && existingRelazione && existingRelazione.length !== 0
                      ? existingRelazione.join(', ')
                      : ''
                  }
                  placement="top"
                  disableHoverListener={isFieldFocused}
                >
                  <TextField
                    helperText="Motivazioni dell’adeguata verifica"
                    sx={{ mt: 1, width: '100%' }}
                    disabled={!modificaCampiVariAbilitato}
                    variant="standard"
                    id="demo-multiple-checkbox"
                    select
                    MenuProps={MenuProps}
                    SelectProps={{
                      multiple: true,
                      value:
                        typeof existingRelazione === 'string' && existingRelazione
                          ? existingRelazione.split(',')
                          : existingRelazione,
                      onChange: multiChangeMotivazioni,
                      renderValue: selected => selected.join(', '),
                    }}
                    onFocus={() => setIsFieldFocused(true)}
                    onBlur={() => setIsFieldFocused(false)}
                    error={errorState && (formValues.relazione === undefined || formValues.relazione === '')}
                    value={formValues.relazione}
                    inputProps={{
                      name: 'relazione',
                      id: 'uncontrolled-native',
                    }}
                  >
                    {listRelazioneA.map(name => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={existingRelazione.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                  </TextField>
                </Tooltip>
              </Grid>
              <Grid item xs={4}>
                {(
                  <Autocomplete
                    name={'daAssegnare'}
                    disabled={!daAssegnareAbilitato}
                    noOptionsText={'Nessun valore corrispondente'}
                    sx={{ width: '100%' }}
                    id="standard-basic"
                    value={formValues.daAssegnare}
                    label="Da assegnare a"
                    required
                    variant="standard"
                    onChange={(event, newValue) => {
                      event.preventDefault();
                      setFormValues({ ...formValues, daAssegnare: newValue });
                    }}
                    options={daAssegnareA !== null ? daAssegnareA : []}
                    inputValue={assegnareA || ''}
                    onInputChange={(event, newInputValue) => {
                      setAssegnareA(newInputValue);
                    }}
                    disablePortal
                    renderInput={params => (
                      <TextField
                        {...params}
                        onChange={handleChange}
                        helperText="Da Assegnare a"
                        fullWidth
                        required
                        variant="standard"
                        autoFocus
                        margin="none"
                        error={errorState && (formValues.daAssegnare === null || formValues.daAssegnare === '')}
                      />
                    )}
                  />)}
              </Grid>

              <Grid item xs={4}>
                {showDettagliorelazione && (
                  <textarea
                    defaultValue={formValues.dettaglioRelazione}
                    disabled={!modificaCampiVariAbilitato}
                    placeholder="Dettaglio Relazione"
                    onChange={event => setFormValues(prev => ({ ...prev, dettaglioRelazione: event.target.value }))}
                    minRows={2}
                    style={{
                      margin: '2px',
                      width: '100%',
                      maxWidth: '100%',
                      height: '100px', // Altezza fissa
                      maxHeight: '100px', // Altezza massima
                      minWidth: '200px', // Larghezza minima
                      overflowY: 'auto', // Scroll verticale
                      borderColor: 'black',
                    }}
                  />
                )}
              </Grid>
            </Grid>
            <Grid alignContent="end" item xs={12}>
              <StyledButton
                disabled={disabledButton}
                onClick={(event, params) =>
                  onClick(event, {
                    ...formValues,
                    relazione: existingRelazione.join(', '),
                  })
                }
                sx={{ margin: 'auto', marginTop: 1, ml: '10px' }}
              >
                SALVA
              </StyledButton>
            </Grid>
            <Grid alignContent="end" item xs={12}>
              <StyledButton
                sx={{ margin: 'auto', marginTop: '0.25em', ml: '10px' }}
                onClick={handleViewModal}
              >
                ESCI
              </StyledButton>
            </Grid>
          </Grid>
        </>
      ) : (
        <div>Loading...</div>
      )}
    </Stack>
  );
}

export default AdeguataVerificaFormModal;
